import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ConfirmGoogleAdsPage = lazy(
  () => import('~/features/onboarding/pages/confirm-google-ads-screen'),
);

/** `connectionId` carries through from the connect step so the metrics tiles
 *  survive a reload on this screen. Same pattern as the GA4 picker route. */
const searchSchema = z.object({
  connectionId: z.string(),
});

function ConfirmGoogleAdsRouteComponent() {
  const { connectionId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConfirmGoogleAdsPage connectionId={connectionId} />
    </Suspense>
  );
}

export const Route = createFileRoute(
  '/_authenticated/_tenant/onboarding/integration/google/google-ads/confirmation',
)({
  validateSearch: searchSchema,
  component: ConfirmGoogleAdsRouteComponent,
});
